import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom'; // Added useLocation hook
import { updateMetaAuthHappening } from '../../store/schemas/authManagementSlice';
import Tilt from 'react-parallax-tilt';
import { useNavigate } from 'react-router-dom'
import { dexie } from '../../helper_functions/dexie';
import { useLiveQuery } from 'dexie-react-hooks';
import { ClientOnly } from '../../../library/client/serverCallHandler';
import { sanitizeUrl } from '../../../node_modules/@braintree/sanitize-url/dist/index';
import CountComp from '../../components/global/counts';
import { getNetworkIcon } from '../../helpers/networkIcons';

const D_NewsletterCell = (props) => {
    const navigate = useNavigate()
    const location = useLocation(); // Added useLocation hook

    const dispatch = useDispatch();
    const newsLetter = useSelector(state => state.mainapp.demoSlice.newsletter);
    const accounts = useSelector((state) => state.authManagement.accounts)
    const url = location.pathname === '/trydemo'; // Updated url variable
    const articles = useLiveQuery(() =>  dexie.posts.orderBy('id').reverse().toArray(), [], []);

    const truncateText = (text, maxLength = 80) => {
        return text.length > maxLength ? text.substring(0, maxLength) + "..." : text;
    }

    const slugify = (text) => {
        return text.toLowerCase().replace(/ /g, '-').replace(/\//g, '');
    }
    const currentSelectedChain = useSelector(state => state.mainapp.chainSlice.currentChain);

    return (
        <>

            <div style={
                articles?.length == 0 ? { height: '50vh' } : null
            } className='hero-center'>

                <h1 >PLURI  Demo
                    on <span>{currentSelectedChain.name}</span>
                </h1>
                {
                    articles?.length == 0 ? <p>
                        Create and store your own content on the blockchain using Pluri. Get started by creating your first post.

                    </p> : <p>Below is your <span>user generated content</span> stored on the blockchain using Pluri.</p>
                }


                <div style={{ margin: '10px 0px' }} className='on-button'>





                    <button onClick={
                        () => {
                            navigate('/' +
                                currentSelectedChain.slug + '/user_console'
                            )
                        }
                    } className='hero-button' >
                        Create Post
                    </button>





                </div>


                {/*     <div className='poweredBy'>
  <img src="assets/metamask.png" alt='metamask' />
  <p>Powered by Metamask</p>

</div> */}
            </div>
            {
                articles?.length == 0 ? <CountComp
                    /*  title={<h1>
                         Simple <span>Setup</span>
                     </h1>}
            
                     description={"Becoming a stakeholder is a simple process that requires you to get the required Pluri, stake it, and earn rewards."}
            */
                    items={
                        [
                            {
                                value: "Connect with Metamask",
                                description: "To claim from the faucet, you need to connect your wallet to the Pluri website using Metamask.",

                            },
                            {
                                value: "Get Pluri from Faucet",
                                description: "Once you have connected your wallet, you can claim Pluri tokens from the faucet to use to make your first post.",

                            },
                            {
                                value: "Create Your First Post",
                                description: "Once you have claimed Pluri tokens, you can create your first post on the blockchain with Pluri.",

                            }
                        ]
                    }
                /> : null

            }


            <div className='newsletter-container vivify fadeIn duration-300'>
                <div className={'article-container'} >
                    <ClientOnly>
                        {
                            () => (
                                articles?.map((item, index) => {
                                    const slug = slugify(item.title);
                                    return (
                                        <Link to={sanitizeUrl(`/${item.network == null ? 'polygon' : item.network}/demo/post/${item.hash}/${slug}`)} key={item.hash}>
                                            <div className='article-item'>
                                                {
                                                    props.compactMode ? null : <div className='article-img demo-img'>
                                                        {
                                                            item.image ? <img src={item.image} alt={item.title} /> : <img src='/assets/unavailable.png' alt={item.title} />
                                                        }
                                                    </div>
                                                }
                                                <div style={{ backgroundColor: !props.compactMode ? null : 'transparent' }} className='article-text'>
                                                    <img style={{width:'25px'}} src={ getNetworkIcon(item.network) } alt={item.network == null ? 'polygon' : item.network} />
                                                    <h4>{item.sub_title}</h4>
                                                    <h3>{item.title}</h3>
                                                </div>
                                            </div>
                                        </Link>
                                    )
                                })
                            )

                        }
                    </ClientOnly>

                </div>
            </div>
            {/* {!url && articles?.length > 3 && (
                <div className='on-button'>
                    <div className='on-button-group' style={{ justifyContent: 'center', marginBottom: '50px' }}>
                        <Tilt tiltMaxAngleX={10} tiltMaxAngleY={10} scale={1.1} glareEnable={true} glareMaxOpacity={0.5} glareColor="#FFFFFF" glarePosition="all">
                            <button className='hero-button' onClick={() => navigate('/articles')}>Read More</button>
                        </Tilt>
                        <Tilt tiltMaxAngleX={10} tiltMaxAngleY={10} scale={1.1} glareEnable={true} glareMaxOpacity={0.5} glareColor="#FFFFFF" glarePosition="all">
                            <button style={{ display: 'none' }}></button>
                        </Tilt>
                    </div>
                </div>
            )} */}

            <style dangerouslySetInnerHTML={{
                __html: `
                .hero-center {
                    height: 45vh
                }

                .hero-center > h1 {
                    margin-top: 0px
                }

                .nav-left > img {
                    filter: hue-rotate(185deg)
                }

                .article-img {
                    background-size: cover;
                }

                ${newsLetter.length == 0 ?
                        `
                        .bolt-button {
                            display: none;
                        }
                        .bolt-notice-block {
                            display: none;
                        }
                        `
                        : ''
                    }
            
            `}} />

        </>
    );
};

export default D_NewsletterCell;
